const bookHealthCheck = (function ($, components) {
    window.dataLayer = window.dataLayer || [];
    const booking = {
        func: {
            init: function () {
                booking.func.bindings();
            },
            bindings: function () {
                $(components.ComplianceInformation.Elements.Buttons.SignUpButton)
                    .on('click', booking.func.handleSignUpButtonClick);
            },
            handleSignUpButtonClick: function () {
                if (components.ComplianceInformation.Func.IsSignUpButtonEnabled()) {
                    components.ComplianceInformation.Func.SwitchToPleaseWaitButton();
                }
            }
        }
    };

    return {
        init: booking.func.init
    };
})(jQuery, {ComplianceInformation: ComplianceInformation});

$('document').ready(function () {
    if ('vitalityhealthcheck' === $('#page-data').data('feature')) {
        bookHealthCheck.init();
    }
});
